/* Dependencies */
import Hotjar from '@hotjar/browser';
import React, { Component } from 'react';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import 'babel-polyfill';
import _ from 'lodash';

import IndexContainer from './IndexContainer';
import SocketWrapper from './SocketWrapper';
import configureI18n from './i18n';
// all CSS being loaded
import './sass/index.sass';
import configureStore from './state/store/configureStore.js';

import '@webscopeio/react-textarea-autocomplete/style.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet/dist/leaflet.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'shepherd.js/dist/css/shepherd.css';

/**
 *    The base instance of TransportialOTMS
 **/
export const store = configureStore();
export const i18n = configureI18n;

const siteId = 3799191;
const hotjarVersion = 6;

export default class TransportialOTMS extends Component {
  componentDidMount() {
    if (process.env.REACT_APP_MODE === 'production') Hotjar.init(siteId, hotjarVersion);
  }

  render() {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <SocketWrapper Page={() => <IndexContainer {...this.props} />} />
        </BrowserRouter>
      </Provider>
    );
  }
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {})
    .catch((err) => {
      console.log('Service worker registration failed, error:', err);
    });
}

const root = createRoot(document.getElementById('transportial'));
root.render(<TransportialOTMS />);
